<template>
  <toolbox-window title="Add Text" icon="text_format" class="text-menu">
    <v-flex
      xs12
      pa-2
    >
      <v-card class="mb-2">
        <v-card-text>
          <v-layout row wrap align-center>
            <v-flex xs12 md4 px-2>
              <v-text-field label="Text" v-model="text" placeholder="Your message here..."/>
            </v-flex>
            <v-flex xs12 md4 px-2>
              <v-select label="Font" :items="fonts" v-model="font" />
            </v-flex>
            <v-flex xs12 md4 px-2>
              <swatches v-model="colour" popover-to="right">
                <v-text-field slot="trigger" label="Colour" :value="colour" readonly>
                  <template slot="prepend">
                    <div
                      :style="{ background: colour }"
                      style="height: 25px; width: 25px; border-radius: 5px; border: 1px solid black;"
                    />
                  </template>
                </v-text-field>
              </swatches>
            </v-flex>
            <v-flex xs12 md4 px-2>
              <v-subheader class="pl-0">Width</v-subheader>
              <v-slider
                v-model="width"
                thumb-label="always"
                :thumb-size="29"
                :min="0.01"
                :max="2"
                :step="0.01"
                hide-details
              ></v-slider>
            </v-flex>
            <v-flex xs12 md4 px-2>
              <v-subheader class="pl-0">Depth</v-subheader>
              <v-slider
                v-model="depth"
                thumb-label="always"
                :thumb-size="29"
                :min="0.01"
                :max="2"
                :step="0.01"
                hide-details
              ></v-slider>
            </v-flex>
            <v-flex xs12 md4 px-2>
              <v-btn color="success" block @click="addText" :disabled="!text">Add text</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </toolbox-window>
</template>

<script>
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.min.css'
import ToolboxWindow from '@/components/SceneToolbox/ToolboxWindow.vue'

export default {
  name: 'TextMenu',
  components: {
    Swatches,
    ToolboxWindow
  },
  data () {
    return {
      text: '',
      width: 1,
      depth: 0.05,
      colour: '#000',
      font: 'optimer-bold',
      fonts: [
        { text: 'Optimer Bold', value: 'optimer-bold' },
        { text: 'Optimer Regular', value: 'optimer-regular' },
        { text: 'Gentilis Bold', value: 'gentilis-bold' },
        { text: 'Gentilis Regular', value: 'gentilis-regular' },
        { text: 'Helvetika Bold', value: 'helvetika-bold' },
        { text: 'Helvetika Regular', value: 'helvetika-regular' }
      ]
    }
  },
  methods: {
    addText () {
      const text = {
        type: 'Text',
        colour: this.colour,
        text: this.text,
        width: this.width,
        depth: this.depth,
        font: this.font,
        scale: {
          x: 1,
          y: 1,
          z: 1
        },
        position: {
          x: 0,
          y: 1,
          z: 0
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0
        }
      }

      this.$store.commit('three/addNode', { node: text })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
